import { gql } from 'graphql-request'

export const availableReports = gql`
  {
    availableReports
  }
`
